/**
 * Copyright (c) 2024 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { LenderTable, Text } from '@blend/enterprise-components';
import { css } from 'aphrodite';
import { JSONTreeView } from 'blb-components/AuthenticatedApp/DashboardPage/JSONTreeView';
import { styles } from 'blb-components/AuthenticatedApp/DashboardPage/DebugTab';
import { get } from 'lodash';
import { DateTime } from 'luxon';

export namespace AuditEventTable {
  export interface Props {
    auditEvents: EClose.FullClosing['auditEvents'];
  }
}

/** AutoTaggingFailures displays renders coordinate-organizer failures in Debug tab*/
export const AuditEventTable: React.FC<AuditEventTable.Props> = ({ auditEvents }) => {
  const rows = auditEvents.map(event => {
    const id: string = get(event, 'id')!;
    const { createdAt, type, meta } = event;
    const createdAtTxt = DateTime.fromISO(createdAt).toLocal().toFormat('yyyy-MM-dd HH:mm:ss ZZZZ');
    return [
      <Text id={`audit-id-${id}`} key={'id'} title={createdAt}>
        {createdAtTxt}
      </Text>,
      <Text id={`audit-type-${id}`} key={'type'}>
        {type}
      </Text>,
      <Text id={`audit-meta-${id}`} key={'meta'}>
        {JSON.stringify(meta)}
      </Text>,
    ];
  });
  return (
    <>
      <LenderTable
        columnWidths={[1, 1, 3]}
        headerTexts={['TIME', 'TYPE', 'META']}
        id="audit-event-table"
        rightAlignLastCol={false}
        sections={rows}
      />
      <pre className={css(styles.snippet)} id={`it-audit-event-debugger`}>
        <JSONTreeView data={auditEvents} />
      </pre>
    </>
  );
};
